<template>
  <div>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe @selection-change="handleSelectionChange" style="margin-top: 20px">
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="产品单位"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="数量"></el-table-column>
          <el-table-column prop="RELATED_SUPPLIER_NAME" label="配送供应商名称"></el-table-column>
          <el-table-column prop="SUPPLIER_REAL_PRICE" label="采购价格"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  notOrderDetailFun,
} from 'api/sellOrder';
// import http from '@/assets/common/http';

export default {
  data() {
    return {
      salesOrderAuditDetail: {},
      tableData: [],
      searchForm: {},
      status: [{ label: '未审核', value: '' }, { label: '已审核', value: '' }],
      multipleSelection: [],
    };
  },
  created() {
    this.salesOrderAuditDetail = JSON.parse(sessionStorage.getItem('salesOrderAudit'));
    this.queryData();
  },
  methods: {
    queryData() {
      const params = {
        ID: Number(this.salesOrderAuditDetail.ID),
      };
      notOrderDetailFun(params).then((result) => {
        if (result[0].TITLE[0].AGENT) {
          sessionStorage.setItem('AGENT', result[0].TITLE[0].AGENT);
        } else {
          sessionStorage.setItem('AGENT', 0);
        }
        if (result[0]) {
          this.tableData = result[0].DETAIL;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitAdd(row) {
      // const params = {
      //   SERVICE_ID: '10030',
      //   OTYPE: 11,
      //   CKS_ID: Number(localStorage.getItem('tcId')),
      //   ORDER_ID: localStorage.getItem('produceId'),
      //   PRODUCT_CODE: row.DP_CODE,
      //   PRODUCT_COUNT: row.COUNT,
      // };
      // http.post(params).then((result) => {
      //   this.$message.show({ text: '添加成功', type: 'success' });
      //   this.queryData();
      // }).catch((error) => {
      //   this.$message.show({ text: error, type: 'error' });
      // });
    },
    detail(row) { },
    audit(row) { },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sendDocument/salesOrderAuditDetail.vue